import {MiddlewareAPI} from 'redux';
import {
  createResourceContainer,
  GetConfigFunc,
  INewMockDataInstance,
  PartialData,
  QueryParameters,
} from '@di-nxt/resource-container';

import {withErrorHandler} from './withErrorHandler';
import {withAuthTokens} from './withAuthTokens';
import {createUseWithErrorHandler} from './createUseWithErrorHandler';
import {createUseWithAuthTokens} from './createUseWithAuthTokens';
import {registerWithStore} from '../../../store/registerWithStore';

export const createEnhancedResourceContainer = <
  TData extends PartialData<TIdKey, any>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  TParameters extends QueryParameters = {},
  TPayload = Record<string, unknown>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(config: {
  scopeKey?: keyof TParameters;
  entityName: TEntityName;
  idKey: TIdKey;
  endPoint: string;
  getConfig: GetConfigFunc;
  mockData: TData[] | ((parameters: TParameters) => TData[]);
  mockHook?: (storeApi: MiddlewareAPI, action: any) => void;
  mockIdFactory: () => TData[TIdKey];
  mockFactory?: INewMockDataInstance<TData, TIdKey, TPayload>;
}) => {
  const {
    component,
    useOperations,
    redux,
    ...restResourceProps
  } = createResourceContainer<
    TData,
    TParameters,
    TPayload,
    TEntityName,
    TIdKey
  >(config);

  registerWithStore(redux);

  const useEnhancedOperations = createUseWithErrorHandler(
    createUseWithAuthTokens(useOperations),
  );

  return {
    component: withErrorHandler(withAuthTokens(component)),
    useOperations: useEnhancedOperations,
    ...restResourceProps,
  };
};
